import EDIT from "../../../assets/edit.svg";

const EditClaimButton = ({
  row, editStateHandler
}) => {

  return (
    <button
        onClick={() => editStateHandler(row)}
        className="table-options-btn"
        >
        <img src={EDIT} alt="" />
    </button>
  )
}

export default EditClaimButton